var exports = {
  "h_": "DuplicateGroupConfirmModal.module__description___YWtGej",
  "o5": "DuplicateGroupConfirmModal.module__channelList___YWtGej",
  "fc": "DuplicateGroupConfirmModal.module__channelItem___YWtGej",
  "R3": "DuplicateGroupConfirmModal.module__avatarWrapper___YWtGej",
  "E8": "DuplicateGroupConfirmModal.module__channelDetails___YWtGej",
  "HA": "DuplicateGroupConfirmModal.module__channelName___YWtGej",
  "Rj": "DuplicateGroupConfirmModal.module__lastActive___YWtGej",
};

module.exports = exports;
